import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/canadian-maple-leaf': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M383.8 351.7c-5 5-10 7.5-5 22.5s10 35.1 10 35.1-95.2-20.1-105.2-22.6c-8.9-0.9-18.4 2.4-18.4 12.5 0 10.1 5.8 112.8 5.8 112.8h-30s5.8-102.8 5.8-112.8-9.6-13.4-18.3-12.5c-10.1 2.5-105.3 22.6-105.3 22.6s5-20.1 10.1-35.1c4.9-15 0-17.5-5.1-22.5-2.6-2.5-105.2-92.4-105.2-92.4l17.5-7.6c10-4.9 7.4-11.4 5-17.4-2.5-7.6-20.1-67.3-20.1-67.3s47.6 10 57.7 12.5c7.5 2.4 10-2.5 12.5-7.5s15-32.3 15-32.3 52.6 59.8 55.1 62.3c10.1 7.5 20.1 0 17.6-10 0-10-27.6-129.6-27.6-129.6s30.1 17.4 40.1 22.4c7.6 5 12.6 5 17.6-5 5-7.5 42.5-79.8 42.5-79.8s37.6 72.3 42.7 79.8c5 10 10.1 10 17.6 5 10-5 40.1-22.4 40.1-22.4s-27.6 119.6-27.6 129.6c-2.5 10 7.6 17.5 17.6 10 2.5-2.4 55.1-62.3 55.1-62.3s12.5 27.4 15 32.4 5 9.9 12.5 7.5c10-2.5 57.7-12.5 57.7-12.5s-17.7 59.7-20.1 67.3c-2.4 5.9-5 12.5 5 17.4l17.5 7.5s-102.7 89.9-105.2 92.4z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/canadian-maple-leaf.js
// module id = 742
// module chunks = 0